import React, { Fragment } from "react";
import UITextField from "../common/ui-components/input/UITextField"
import UITextArea from "../common/ui-components/input/UITextArea"
import Button from "../common/ui-components/input/Button"
import UIDropdown from "../common/ui-components/input/UIDropdown/UIDropdown"
import styles from "../../styles/pages/contact-us.module.scss"
import ContactBanner from './ContactBanner'
import { PostForm } from "../../api/contact-us/index"
import UIModal from '../common/ui-components/surface/UIModal'
import { useRouter } from 'next/router'
import Image from '../common/Image';
import { Hidden } from "@mui/material";
import { getStaticPath, openDialer } from "../../utils";
import { validateFiles } from "../../utils/fileHandler";
import { CUSTOMER_CARE_NUMBER } from "../../constants";

interface Props {
    subissues: {
        [key: string]: string[]
    },
    customer?:any
}


const Form = (props: Props) => {

    const [issue, setIssue] = React.useState<any>(null)
    const [subIssue, setSubIssue] = React.useState<any>([{
        text: 'Select Sub-Issue',
        value: 'Select Sub-Issue',
        key: 0
    }])
    const [errorName,setErrorName] = React.useState<string>("")
    const [errorEmail,setErrorEmail] = React.useState<string>("")
    const [errorPhone,setErrorPhone] = React.useState<string>("")
    const [errorIssue,setErrorIssue] = React.useState<string>("")
    const [errorSubIssue,setErrorSubIssue] = React.useState<string>("")
    const [subissues, setSubIssues] = React.useState<any>(null)
    const [name, setName] = React.useState<string>("")
    const [phone, setPhone] = React.useState<string>("")
    const [mail, setMail] = React.useState<string>("")
    const [comment, setComment] = React.useState<string>("")
    const [file, setFile] = React.useState<Blob| any>()
    const [filename, setFilename] = React.useState<string>("")
    const [thanks,setThanks] = React.useState<boolean>(false)
    const [,setFields] = React.useState<boolean>(true)
    const [modal,setModal] = React.useState<boolean>(false)
    const [reqsent,setReqsent] = React.useState<boolean>(false)
    const [issueBorder, setIBorder] = React.useState<boolean>(true)
    const [subissueBorder, setSBorder] = React.useState<boolean>(true)
    const [fileVal, setFileVal] = React.useState<boolean>(true) 
    const handleSelect = (e) => {
        setErrorIssue("")
        setIBorder(true)
        setIssue(e["value"])
        let b = props.subissues[e["text"]].map(myfunc)
        setSubIssue(b)
        setSubIssues(null)
        return false
    }

    const handleSelectSub = (e) => {
        setErrorSubIssue("")
        setSBorder(true)
        setSubIssues(e["value"])
        return false
    }
    const handleSelectName = (e) => {
        setErrorName("")
        setName(e.target.value)
    }
    const handleSelectMail = (e) => {
        setErrorEmail("")
        setMail(e.target.value)
    }
    const handleSelectPhone = (e) => {
        setErrorPhone("")
        setPhone(e.target.value)
    }
    const handleSelectComment = (e) => {
        setComment(e.target.value)
    }
    const handleFile = async (e) => {
        const supported:any = ["jpeg", "jpg", "png", "doc", "docx", "pdf"]
        const validateFile = await validateFiles(e.target.files[0],supported,5120)
        if(validateFile['valid']){
            setFileVal(true)
            setFile(e.target.files[0])
            setFilename(e.target.files[0].name)
        }
        else{
            setFileVal(false)
        }
        return false;
    }
    const validateEmail = (email) => {
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const valPhone = (phone) => {
        const re = /^\d{10}$/
        return re.test(phone);
    }
    const getvalue = (e) => {
        if(name===""||mail===""||phone===""||issue===null||subissues===null||!validateEmail(mail)||!valPhone(phone))
        {
          if(name==="")
          {
              setErrorName("Required fields")
          }
          if(mail==="")
          {
              setErrorEmail("Required fields")
          }
          if(phone==="")
          {
              setErrorPhone("Required fields")
          }
          if(issue===null)
          {
              setIBorder(false)
              setErrorIssue("Required fields")
          }
          if(subissues===null)
          {
              setSBorder(false)
              setErrorSubIssue("Required fields")
          }
          
            setFields(false)
            let element = document.getElementById("name");
            if(element)
            window.scrollTo({
                top: element.getBoundingClientRect().top+window.pageYOffset-110,
                behavior: "smooth"
            });
        }
        else
        {
        e.preventDefault()
        const data = new FormData()
        data.append("name", name)
        data.append("email", mail)
        data.append("phone", phone)
        data.append("issue", issue)
        data.append("sub_issue", subissues)
        data.append("comment", comment)
        data.append("subject", "Query raised via WebForm")
        if(filename!==""){data.append("doc", file, filename)}
        if(reqsent===false){
           
        PostForm(data)
        setReqsent(true)
        }
        setName("")
        setPhone("")
        setMail("")
        setComment("")
        setIssue(null)
        setSubIssues(null)
        setFilename("")
        setFile("")
        setFields(true)
        setThanks(true)
        setModal(true)
        return false
        }
    }
    const closemodal = () => {
        setModal(!modal)
        setThanks(false)
        return false
    }
    const router = useRouter()
    const remove = (e) => {
        e.preventDefault()
        setFilename("")
    }

    React.useEffect(()=>{
        if(props.customer.is_authenticate){
            setName(props.customer.name)
            setPhone(props.customer.phone)
            setMail(props.customer.email)
        }
    })
    if (!props.subissues) {
        return null
    }
    const options: any[] = [
        {
            text: "Get my device repaired",
            value: "Get my device repaired",
            key: 1,
        },
        {
            text: "Know the repair status",
            value: "Know the repair status",
            key: 2,
        },
        {
            text: "Get my registration certificate",
            value: "Get my registration certificate",
            key: 3,
        },
        {
            text: "Purchase a new plan",
            value: "Purchase a new plan",
            key: 4,
        },
        {
            text: "Complain",
            value: "Complain",
            key: 5,
        },
        {
            text: "Know about my refunds",
            value: "Know about my refunds",
            key: 6,
        },
        {
            text: "Appreciate / share feedback",
            value: "Appreciate / share feedback",
            key: 7,
        },
    ]

    function myfunc(val) {
        return {
            value: val,
            text: val,
            key: val
        }
    }
    let showing = filename !== "" ? filename : "Choose file .jpg, .jpeg, .png, .doc, .pdf, .docx not more than 5MB"
    let che = filename !== "" ? <label htmlFor="remove" className={`${styles.remove__button}`}>Remove</label> : ""


    return (
        <Fragment>
            {   thanks ?
           
                <UIModal  className="thankyou-modal" isOpen={modal} larger={false} onClick={closemodal}>
                    <h2>Thank You</h2>
                    <p>We have noted your concern. A query has been raised. An Onsitego representative will get in touch with you soon to help you. The ticket reference number will be emailed to you along with details of the query.</p>
                    <Button onClick={ () => {window.scrollTo(0,0);router.push('/'); }}>Go to Home</Button>
                </UIModal>
            :
            ""
            }
            <div className="container contactus">
                <div className="row">
                    <div className={`${styles.formdiv} col-12 col-lg-6`} >
                        <h2 className={`${styles.formdiv__heading}`}>How Can We Help Today?</h2>
                        <p className={`${styles.formdiv__para}`}>You can fill the following form to address your issues.</p>
                        <form method="POST" action="#">
                            <div className={`${styles.padding_div}`}><UITextField id="name" isForm={true} noLabel={false} className={`${styles.formdiv__textfield}`} type="text" isRequired={true} value={name} label="Full Name" propsError={errorName} onChange={(e: any) => handleSelectName(e)} />
                            
                            </div>
                            <div className={`${styles.padding_div}`}><UITextField id="mail" isForm={true} noLabel={false} className={`${styles.formdiv__textfield}`} regExp={/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/} isRequired={true} value={mail} propsError={errorEmail} label="Email Address" onChange={(e: any) => handleSelectMail(e)} />
                            </div>
                            <div className={`${styles.padding_div}`}><UITextField id="phone" isForm={true} noLabel={false} className={`${styles.formdiv__textfield}`} type="tel" isRequired={true} value={phone} regExp={/^\d{10}$/} label="Contact Number"  onChange={(e: any) => handleSelectPhone(e)} propsError={errorPhone}/>
            
                            </div>

                            <div className={ issue!==null ? `${styles.formdiv__fontbold} ${styles.formdiv__dropdown}`: ` ${styles.formdiv__dropdown}`}><UIDropdown label={"Issue"} isRequired={true} className={ issueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} propsError={errorIssue} options={options} selected_option={issue === null ? null : { text: issue, value: issue, key: issue }} placeholder="Select Issue" onChange={(e: React.ChangeEvent<{}>) => handleSelect(e)} /> </div>
                            <div className={subissues!==null ? `${styles.formdiv__fontbold} ${styles.formdiv__dropdown}`: ` ${styles.formdiv__dropdown}`}><UIDropdown  label={"Sub-Issue"} isRequired={true} className={ subissueBorder ? `${styles.bordering}` : `${styles.bordering__error}`} options={subIssue} propsError={errorSubIssue} placeholder="Select Sub-Issue" selected_option={subissues === null ? null : { text: subissues, value: subissues, key: subissues }} onChange={(e: React.ChangeEvent<{}>) => handleSelectSub(e)} /> </div>
                            <UITextArea  noPlaceholder={true} className={`${styles.formdiv__textfieldlong}`}  label="Your Comments(Optional)" value={comment} onChange={(e: any) => handleSelectComment(e)} />
                            <div className={`${styles.uploadfile_flex}`}>
                                <input id="file_button" type="file" onChange={(e: React.ChangeEvent<{}>) => handleFile(e)} hidden={true} />

                                <div className={`${styles.upload__img}`}>
                                <Image src="/static/images/contactus/computing-cloud.png" alt={"placeholder"} width="730" height="516" /> 
                                    </div>
                                <div className={`${styles.uploadsection}`}><label htmlFor="file_button" className={`${styles.custom_input}`} >Upload File (optional) </label>
                                    <button id="remove" hidden={true} onClick={(e: React.ChangeEvent<{}>) => remove(e)}></button>

                                    <p className={`${fileVal ? `${styles.upload__help}` : `${styles.upload__error}`} ${filename!==""? `${styles.upload__filename}`:""}`}>{showing}{che}</p>
                                </div>
                            </div>
                            <Button className={`${styles.formdiv__button}`} text="Submit Details" onClick={(e: React.ChangeEvent<{}>) => getvalue(e)} />

                        </form>
                    </div>
                    <div className={`${styles.address} col-12 col-lg-6`}>
                        <div className={`${styles.address__inlining}`}>
                        <Image src="/static/images/contactus/group-17.png" alt={"placeholder"}  width="15" height="20" /> 
                            <p className={`${styles.address__office}`}> &nbsp; Our Office address</p>
                        </div>
                        <Hidden mdDown> <p className={`${styles.address__line}`}>Skyline Icon, G-3A, 86/92, Andheri - Kurla Rd, Chimatpada,<br />
                        Marol, Andheri East, Mumbai, Maharashtra 400059</p>
                        <div className={`${styles.contact__inlining}`}>
                        <Image src="/static/images/contactus/phone-call.png" width="140px" height="18px"></Image>
                        </div>
                        </Hidden>
                        <Hidden mdUp > <p className={`${styles.address__line}`}>Skyline Icon, G-3A, 86/92, Andheri - Kurla Rd, Chimatpada,
                        Marol, Andheri East, Mumbai, Maharashtra 400059</p>
                        <div className={`${styles.contact__inlining}`}>
                        <a onClick={() => openDialer(CUSTOMER_CARE_NUMBER)}><Image src="/static/images/contactus/phone-call.png" width="140px" height="18px"></Image></a>
                        </div>
                        </Hidden>
                        <a  href="https://goo.gl/maps/rzRUCc2ZzpTAttLU6" target="_blank" rel="noopener noreferrer">
                        <div className={`${styles.Map} map`}> 
                            <img src="/static/images/contact-us-map.png" alt="map"></img>
                        </div>
                        </a>
                       
                    </div>
                </div>
                
            </div>
            <ContactBanner />
           
             </Fragment>
    );
    
}

export default Form;